import React from 'react';
import InnerBlock from '../../../../shared/web/layout/InnerBlock';
import { SettingsBreadcrumbs } from '../../../settingsModule';
import { Breadcrumb } from '../../../../shared/web/layout/Breadcrumbs';
import MarketsRequestsList from './MarketsRequestsList';

export default function MarketsRequestsPage() {
  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Market Requests" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Market Requests">
        <MarketsRequestsList />
      </InnerBlock>
    </>
  )
}
